import { DisplayData, DisplayDataProps, DisplayDataWidget, translateLabelForData } from "@me8eon/data";
import { TeamsData } from "./teams.data";
import { useAttributeValueComponents, useRenderers } from "@me8eon/renderers";
import { Icon } from "@me8eon/icons";
import { SimpleWidget } from "@me8eon/simple_widget";

export const TeamsDisplay: DisplayData<TeamsData> =
    ({ rootId, id, data }: DisplayDataProps<TeamsData>) => {
        const { H3, Url, Text: JustText } = useRenderers();
        const { Text, DataLayout } = useAttributeValueComponents();
        const newRootId = `${rootId}.${id}`;
        const resource = data.resource;

        if (!resource) {
            console.log('TeamsDisplay: no resource', data);
            return <div>No Teams message data available</div>;
        }

        const { body, from, createdDateTime } = resource;

        const senderName = from?.user?.displayName || "Unknown Sender";
        const senderUPN = from?.user?.userPrincipalName || "";
        const messageContent = body?.content || "";
        const messageInitials = senderName
            .split(" ")
            .map((n) => n.charAt(0))
            .join("");

        return (
            <DataLayout rootId={newRootId} className="teams-data" layout={[2]}>
                <div style={{ display: "flex", gap: "10px" }}>
                    <div style={{
                        height: "100px",
                        fontSize: "40px",
                        minWidth: "100px",
                        backgroundColor: "var(--bg-hover-color)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>
                        {messageInitials}
                    </div>
                    <div>
                        <H3
                            rootId={newRootId}
                            attribute={translateLabelForData("sender")}
                            value={senderName}
                        />
                        <JustText
                            rootId={newRootId}
                            attribute={translateLabelForData("userPrincipalName")}
                            value={senderUPN}
                        />
                        <JustText
                            rootId={newRootId}
                            attribute={translateLabelForData("created")}
                            value={new Date(createdDateTime).toLocaleString()}
                        />
                        <Text
                            rootId={newRootId}
                            attribute={translateLabelForData("message")}
                            value={messageContent}
                        />
                    </div>
                </div>
                <div>
                    {/* Optionally, add actionable links if available */}
                </div>
            </DataLayout>
        );
    };

export const OneLineTeamsDisplay: DisplayData<TeamsData> =
    ({ data }: DisplayDataProps<TeamsData>) => {
        const sender = data.resource.from?.user?.displayName || "Unknown";
        const messageSnippet = data.resource.body?.content?.substring(0, 50) || "";
        return <span>{data.type} - {sender}: {messageSnippet}...</span>;
    };

export const SimpleTeamsWidget: DisplayDataWidget<TeamsData> =
    SimpleWidget(
        [],
        [],
        []
    );
